import { render } from "./TheLoader.vue?vue&type=template&id=4e8269e4"
import script from "./TheLoader.vue?vue&type=script&lang=js"
export * from "./TheLoader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/TheLoader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4e8269e4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4e8269e4', __exports__)) {
    api.reload('4e8269e4', __exports__)
  }
  
  module.hot.accept("./TheLoader.vue?vue&type=template&id=4e8269e4", () => {
    api.rerender('4e8269e4', render)
  })

}


export default __exports__